<template>
    <div class="h-full flex flex-col p-4">
        <base-card class="h-full flex flex-col">
          <div>upload-statement form</div>
        </base-card>
    </div>
  </template>
  
  <script>
  export default {
    name: "upload-statement-index",
    data() {
      return {
      };
    },
  };
  </script>
  
  <style lang="scss" scoped>
  </style>
  